import { useNavigate } from 'react-router-dom';
import { AddPlantForm } from './AddPlantForm';
import { ResponsiveModal, ResponsiveModalBody } from '../ui';

interface AddPlantModalProps {
  isOpen: boolean;
  onClose: () => void;
  defaultSourceId?: string;
}

export function AddPlantModal({ isOpen, onClose, defaultSourceId }: AddPlantModalProps) {
  const navigate = useNavigate();

  const handleSuccess = (plantId: string) => {
    onClose();
    // Navigate to the newly created plant
    navigate(`/plants/${plantId}`);
  };

  return (
    <ResponsiveModal isOpen={isOpen} onClose={onClose} size="md">
      <ResponsiveModalBody>
        <AddPlantForm
          onSuccess={handleSuccess}
          onCancel={onClose}
          defaultSourceId={defaultSourceId}
        />
      </ResponsiveModalBody>
    </ResponsiveModal>
  );
}
